import { getGlobalCookie } from '.';
import config from '../config';
import mixpanel from 'mixpanel-browser';
import { store } from "../store";
const userinfo = JSON.parse(getGlobalCookie('lessorAccess'))

var distinct_id
mixpanel.init(
  config.mixpanel.key, {
  debug: true,
  loaded: function (mixpanel) {
    distinct_id = mixpanel.get_distinct_id()
  }
},
);


export const trackUser = (user, callback) => {
  const state = store.getState();
  const userLessorList = state?.leases?.userLessorList;
  const lessorName = userLessorList?.find(item => item?.id === user?.id)?.name || '';

  if (user !== undefined && user !== null) {
    mixpanel.people.set({
      name: user?.user?.name,
      user_id: user?.user?.id,
      lessor_name: lessorName,
      lessor_id: user?.id ? user.id : '',
      user_type: user?.user?.type?.label
    });
    mixpanel.identify(user?.user?.id)
    callback()
  }
}

export const trackActivity = (activityName, metadata) => {
  trackUser(userinfo,() => {
    mixpanel.track(
      activityName,
      {
        ...metadata,
        application_module: 'Lease Revamp',
      }
    )
  })
}

export const trackFeatureActivity = (activityName, metadata = {}) => {
  mixpanel.track(
    activityName,
    metadata
  )
  mixpanel.identify(distinct_id)
}
